import React from "react";
import {
  Box,
  Typography,
  FormControl,
  OutlinedInput,
  InputAdornment,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import SearchResult from "../../components/SearchResult";
import ApiService from "../../services/api-service";
import Loader from "./../../components/Loader";
import PageHeader from "../../components/PageHeader";
import OutsideClickHandler from "react-outside-click-handler";
import AddMusicToPlaylist from "../../components/AddMusicToPlaylist";
import { useTranslation } from "react-i18next";
export default function Search({ showClose }) {
  const { t } = useTranslation("common");
  const [showPlaylist, setShowPlaylist] = React.useState(false);
  const [selectedIndex, setSelectedIndex] = React.useState(null);
  const [selectedId, setSelectedAlbum] = React.useState();
  const [focus, setFocus] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [user, setUser] = React.useState([]);
  const [playlist, setPlaylist] = React.useState([]);
  const [music, setMusic] = React.useState([]);
  const [keyword, setKeyword] = React.useState("");
  // const handleUserSearch = async (keyword) => {
  //   if (keyword) {
  //     try {
  //       setLoading(true);
  //       const response = await ApiService.SEARCH_USER(keyword);
  //       setUser([...response["result"]]);
  //       setLoading(false);
  //     } catch (error) {
  //       console.error(error);
  //       setLoading(false);
  //     }
  //   }
  // };
  // const handlePlaylistSearch = async (keyword) => {
  //   if (keyword) {
  //     try {
  //       setLoading(true);
  //       const response = await ApiService.SEARCH_PLAYLIST(keyword);
  //       setPlaylist([...response["result"]]);
  //       setLoading(false);
  //     } catch (error) {
  //       console.error(error);
  //       setLoading(false);
  //     }
  //   }
  // };
  // const handleMusicSearch = async (keyword) => {
  //   if (keyword) {
  //     try {
  //       setLoading(true);
  //       const response = await ApiService.SEARCH_MUSIC(keyword);
  //       setMusic([...response["result"]]);
  //       setLoading(false);
  //     } catch (error) {
  //       console.error(error);
  //       setLoading(false);
  //     }
  //   }
  // };

  const handleSearch = async (keyword) => {
    if (keyword) {
      try {
        setLoading(true);
        const response = await ApiService.SEARCH(keyword);
        setMusic([...response["result"]["music"]]);
        setPlaylist([...response["result"]["studio"]]);
        setUser([...response["result"]["artist"]]);
        setLoading(false);
      } catch (error) {
        console.error(error);
        setLoading(false);
      }
    }
  };

  // React.useEffect(() => {
  //   // handleUserSearch(keyword);
  //   // handleMusicSearch(keyword);
  //   // handlePlaylistSearch(keyword);
  // }, [keyword]);
  // Listen for keystroke events
  var typingTimer; //timer identifier
  var doneTypingInterval = 1000; //time in ms, 5 seconds for example

  const onKeyup = () => {
    clearTimeout(typingTimer);
    typingTimer = setTimeout(doneTyping, doneTypingInterval);
  };
  const onkeydown = () => {
    clearTimeout(typingTimer);
  };
  //user is "finished typing," do something
  function doneTyping() {
    setFocus(true);
    //do something
    //console.log("Done");
    //if word length is greater than 3 then call the api.
    if (keyword.length >= 3) {
      // handleUserSearch(keyword);
      // handleMusicSearch(keyword);
      // handlePlaylistSearch(keyword);
      handleSearch(keyword);
    }
  }
  return (
    <Box
      sx={{
        width: showClose ? "100%" : "80%",
        position: "relative",
        height: "42px",
        paddingLeft: "18px",
      }}
    >
      <OutlinedInput
        sx={{
          width: showClose ? "100%" : "80%",
          borderRadius: "25px",
          height: "42px",
        }}
        id="search-input"
        placeholder={t("header.search")}
        value={keyword}
        onChange={(e) => (setKeyword(e.target.value), setFocus(false))}
        onKeyUp={() => onKeyup()}
        onKeyDown={() => onkeydown()}
        startAdornment={
          <InputAdornment position="start" id="_search_icon">
            {showClose ?? <SearchIcon />}
          </InputAdornment>
        }
        aria-describedby="outlined-weight-helper-text"
        inputProps={{
          "aria-label": "Search Artist, Song, Studio Name",
        }}
        autoComplete="off"
      />
      {focus ? (
        <OutsideClickHandler
          onOutsideClick={() => {
            setKeyword("");
            setFocus(false);
          }}
        >
          <SearchResult
            handleClose={() => {
              setKeyword("");
              setFocus(false);
            }}
            keyword={keyword}
            users={user}
            musics={music}
            playlists={playlist}
            onShowAddPlaylist={(musicId, show) => {
              setSelectedAlbum(musicId);
              setShowPlaylist(show);
            }}
          />
        </OutsideClickHandler>
      ) : null}

      {loading ? <Loader /> : null}
      {showPlaylist ? (
        <AddMusicToPlaylist
          musicId={selectedId}
          open={showPlaylist}
          handleClose={() => {
            setShowPlaylist(false);
          }}
        />
      ) : null}
    </Box>
  );
}
